import React, { useState } from "react";
import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, theme } from "antd";
import { Route, Routes, useNavigate } from "react-router-dom";
import RegisterStudent from "./professor/registerstudent";
import GetlistStudent from "./professor/getlistStudent";
import AssignPatint from "./professor/assignPatient";
import ReportLabeling from "./professor/reportLabeling";
import ReportExam from "./professor/reportExam";
import ReportFinal from "./professor/reportFinal";
import RegisterLateralCephalo from "./professor/registerLateralCephalo";
import RegisterNumberingTeethUser from "./professor/registerNumberingTeethUser";
import RegisterImplantUser from "./professor/registerImplantUser";
import RegisterSegmentCaries from "./professor/registerSegmentCaries";
import RegisterProfileAnalysisUser from "./professor/registerProfileAnalysisUser";
import RegisterOPgNumbering from "./professor/registerOPgNumbering";
import Registerperiapicallesionuser from "./professor/registerperiapicallesionuser";
import RegistercbctaiUser from "./professor/registercbctaiUser";
const { Header, Content, Footer, Sider } = Layout;
function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
const items = [
  getItem("دانشجویان", "sub1", <UserOutlined />, [
    getItem("ثبت دانشجو جدید", "registerstudent"),
    getItem("لیست دانشجویان", "liststudent"),
    getItem(" assign کردن بیمار  ", "assignPatient"),
    getItem("ثبت کاربر آنالیز سفالو جدید", "registerCephaloUser"),
    getItem("ثبت کاربر آنالیز شماره دندان جدید", "registerNumberingTeethUser"),
    getItem("ثبت کاربر ایمپلنت", "registerImplantUser"),
    getItem("ثبت کاربر پوسیدگی دندان", "registerSegmentCariesUser"),
    getItem("ثبت کاربر  آنالیز پروفایل", "registerProfileAnalysisUser"),
    getItem("ثبت کاربر  آنالیز پانورامیک", "registeropgnumberingUser"),
    getItem("ثبت کاربر  ضایعه پریاپیکال ", "registerperiapicallesionuser"),
    getItem("ثبت کاربر   آنالیز سی بی سی تی ", "registercbctaiUser"),
  ]),
  getItem("گزارش عملکرد", "sub2", <PieChartOutlined />, [
    getItem("گزارش عملکرد", "reportLabeling", <PieChartOutlined />),
    getItem("گزارش آزمون", "reportExam", <PieChartOutlined />),
    getItem("گزارش عملکرد نهایی", "reportfinal", <PieChartOutlined />),
  ]),
];
const App = () => {
  const [collapsed, setCollapsed] = useState(true);
  const navigation = useNavigate();
  const _onClickMenu = (menuItem) => {
    setCollapsed(true);
    navigation(menuItem.key);
  };
  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          defaultSelectedKeys={["1"]}
          mode="inline"
          items={items}
          onClick={_onClickMenu}
        />
      </Sider>
      <Layout>
        <Content
          style={{
            margin: "10px 20px",
          }}
        >
          <Routes>
            <Route path="/registerstudent" element={<RegisterStudent />} />
            <Route path="/liststudent" element={<GetlistStudent />} />
            <Route path="/assignPatient" element={<AssignPatint />} />
            <Route path="/reportLabeling" element={<ReportLabeling />} />
            <Route path="/reportexam" element={<ReportExam />} />
            <Route path="/reportfinal" element={<ReportFinal />} />
            <Route
              path="/registerCephaloUser"
              element={<RegisterLateralCephalo />}
            />
            <Route
              path="/registerNumberingTeethUser"
              element={<RegisterNumberingTeethUser />}
            />
            <Route
              path="/registerSegmentCariesUser"
              element={<RegisterSegmentCaries />}
            />
            <Route
              path="/registerImplantUser"
              element={<RegisterImplantUser />}
            />
            <Route
              path="/registerProfileAnalysisUser"
              element={<RegisterProfileAnalysisUser />}
            />
            <Route
              path="/registeropgnumberingUser"
              element={<RegisterOPgNumbering />}
            />
            <Route
              path="/registerperiapicallesionuser"
              element={<Registerperiapicallesionuser />}
            />
            <Route
              path="/registercbctaiUser"
              element={<RegistercbctaiUser />}
            />
          </Routes>
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        ></Footer>
      </Layout>
    </Layout>
  );
};
export default App;
